import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeadphones: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconHeadphones"><Path d="M4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12V13H18.25C16.7312 13 15.5 14.2312 15.5 15.75V18.25C15.5 19.7688 16.7312 21 18.25 21C19.7688 21 21 19.7688 21 18.25V12C21 7.282 17.3696 3.41192 12.75 3.03081V3H12C7.02944 3 3 7.02944 3 12V18.25C3 19.7688 4.23122 21 5.75 21C7.26878 21 8.5 19.7688 8.5 18.25V15.75C8.5 14.2312 7.26878 13 5.75 13H4.5V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHeadphones;
